import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentEnvironmentName } from '../selectors/current-environment-name.selector.ts';

export const CurrentEnvironment: FC = memo(() => {
  const environment = useSelector(selectCurrentEnvironmentName);
  if (!environment || environment === 'production') return null;

  return (
    <div className="bg-neutral-darkest text-neutral-lighter fixed bottom-1 left-1 z-50 rounded-sm p-1 text-xs">
      {environment}
    </div>
  );
});

CurrentEnvironment.displayName = 'CurrentEnvironment';
